import { createFileRoute } from '@tanstack/react-router';
import { OrgFunctionDetailPage } from '@/pages/organization/org-functions/OrgFunctionDetailPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';

export const Route = createFileRoute('/$slug/organization/functions/$orgFunctionId')({
  loader: createEntityBreadcrumbLoader('function', 'orgFunctionId'),
  component: RouteComponent
});

function RouteComponent() {
  const { orgFunctionId } = Route.useParams();
  return <OrgFunctionDetailPage orgFunctionId={orgFunctionId} kind="role" />;
}
